const d3 = Object.assign(
    {},
    require("d3-array"),
    require("d3-selection"),
    require("d3-fetch"),
    require("d3-transition"),
    require("d3-ease"),
    require("d3-scale")
)
import "lodash"
import getDimensions from "./d3-camera-dimensions"
import drawBase from "./d3-camera-drawBase"
import { drawContent, redraw, hideToolTip } from "./d3-camera-drawContent"
import { drawBrush, removeBrush } from "./d3-camera-drawBrush"

export default class CameraViz {
    constructor(DOMtarget, dataset) {
        this.DOMtarget = DOMtarget
        this.dataset = dataset
        this.sumView = null
        this.localStorage = null
        this.wrapper = null // bounding svg - used for height calculations

        this.dimensions = getDimensions(this.DOMtarget)

        // Data
        if (localStorage.getItem("d3_cameraSettings") === null) {
            this.zoomScale = 1
            this.selectedDimensionText = "Focal Length"
                      
        } else {
            
            let locStorage = JSON.parse(localStorage.getItem("d3_cameraSettings"))
            this.zoomScale = locStorage.settings.zoomScale
            this.selectedDimensionText = locStorage.settings.selectedDimensionText
           
        }
        
         
        // Dimensions
        this.selectedDimension = _.snakeCase(this.selectedDimensionText) 
        this.selectedValue = null
        this.selectedBrand = null

        // Accessors
        this.cameraAccessor = d => +d.exif.focal_length
        this.sumAccessor = d => +d.amount

        // Scales
        this.scaleX = null
        this.scaleR = null

        // Transitions
        this.trans = d3
            .transition()
            .duration(2000)
            .ease(d3.easeLinear)
    }

    async loadData(fileName) {
        const theDataSet = await d3.json(`/data/${fileName}.json`)
        console.log(`This dataset contains ${theDataSet.length} photos`)
        this.dataset = theDataSet
        return theDataSet
    }

    init() {
        
        if (localStorage.getItem("d3_cameraSettings") === null) {
            const locStorage = {}
            locStorage.settings = {}
            locStorage.settings.zoomScale = this.zoomScale
            locStorage.settings.selectedDimensionText = this.selectedDimensionText
            window.localStorage.setItem("d3_cameraSettings", JSON.stringify(locStorage))
        }

        // Brand data
        window.localStorage.setItem("d3_camera", JSON.stringify({}))
        


        this.initScales()
    }

    initScales() {
        this.scaleX = d3
            .scaleLinear()
            .domain(d3.extent(this.dataset, this.cameraAccessor))
            .range([
                this.dimensions.margin.left,
                this.dimensions.width - this.dimensions.margin.right
            ])

        this.scaleBrush = d3
            .scaleLinear()
            .domain(d3.extent(this.dataset, this.cameraAccessor))
            .range([
                this.dimensions.margin.left,
                this.dimensions.width - this.dimensions.margin.right
            ])

        this.scaleR = d3
            .scaleSqrt()
            .domain([1, this.dataset.length / 20])
            .range([2, 20])
    }

    resize() {
        this.dimensions = getDimensions(this.DOMtarget)
        this.init()
        this.drawBase()
        this.drawContent(this.data)
    }

    resetZoom() {
        this.scaleX.domain(d3.extent(this.dataset, this.cameraAccessor))
    }

    changeDimensions(dimension) {
        this.selectedDimension = _.snakeCase(dimension)
        this.selectedDimensionText = dimension

        let locStorage = JSON.parse(localStorage.getItem("d3_cameraSettings"))
        locStorage.settings.selectedDimensionText = this.selectedDimensionText
        window.localStorage.setItem("d3_cameraSettings", JSON.stringify(locStorage))

        switch (this.selectedDimension) {
        case "focal_length":
            this.cameraAccessor = d => +d.exif.focal_length
            break
        case "iso":
            this.cameraAccessor = d => +d.exif.iso
            break
        case "aperture":
            this.cameraAccessor = d => +d.exif.aperture
            break
        case "exposure_time":
            this.cameraAccessor = d => {
                let key = d.exif.exposure_time
                let text
                if (key) {
                    text = key.toString()

                    const invalidKey = key.toString().indexOf("/")
                    if (invalidKey > 0) {
                        const divider = Number(key.toString().split("/")[1])
                        key = (1 / divider) * 1000
                    } else {
                        key = Number(key.toString()) * 1000
                    }
                } else {
                    text = "not provided"
                }

                return key
            }
            break
        default:
            this.cameraAccessor = d => +d.exif.focal_length
        }
        this.initScales()
        this.redraw(this.zoomScale)
    }
}

Object.assign(CameraViz.prototype, {
    drawBase,
    drawContent,
    drawBrush,
    removeBrush,
    redraw,
    hideToolTip
})
